import { Button } from "antd";
import "./styles.scss";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-section-inner container">
        <h1 className="color-white">
          Agape IT, your partner in innovative IT Solutions
        </h1>
        <div className="hero-section-inner-desc">
          <p className="color-white">
            Our team of experts is dedicated to providing cutting-edge
            technology services that drive efficiency, productivity, and growth
            for your business.
          </p>
          <Button size="large" type="primary">
            Free Consulting
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
